import { AdminMatch, DepartmentSuperAdmins } from 'domains/user'

import { protectedApi } from './requester'

export const findAdmins = (countries: string[], departments: string[]): Promise<AdminMatch[]> => {
  const params = new URLSearchParams()

  countries.forEach((country) => params.append('countries', country))
  departments.forEach((department) => params.append('departments', department))

  const query = params.toString()
  const url = query ? `/admins/search?${query}` : '/admins/search'

  return protectedApi.get<AdminMatch[]>(url).then((response) => response.data)
}

export const getDepartmentSuperAdmins = (): Promise<DepartmentSuperAdmins[]> =>
  protectedApi.get<DepartmentSuperAdmins[]>('/admins/departments').then((response) => response.data)
